import { Reducer } from 'redux';
import { BudgetsState, BudgetsTypes } from './types';

const INITIAL_STATE: BudgetsState = {
  pagination: {
    current: 1,
    pageSize: 12,
    total: 12,
  },
  data: [],
  loading: false,
};

const reducer: Reducer<BudgetsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BudgetsTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case BudgetsTypes.LOAD_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        error: undefined,
      };
    case BudgetsTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
